<template>
  <div>
    <ProcurePage></ProcurePage>
  </div>
</template>
<script>
import api from '@/apis/api.js';
export default {
  name: 'PurchasingList',
  data () {
    return {
    }
  },
  components: {
		ProcurePage: resolve => require(["@/components/InvoiceManage/ProcurePage.vue"],resolve),
  },
  watch: {

  },
  filters:{
  },
  methods: {
		
  },
  created() {
  },
  mounted (){
    
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/InvoiceManage/PurchasingList.vue